console.log("ga-custom-events.js loaded");

document.addEventListener("click", (event) => {
    // deactivating for the next release, needs further testing
    return;

    if (event.target.name === "add") {
        const source = event.target.dataset.buttonLocation || "unknown";
        console.log("add to cart button clicked", source);
        if (!Shopify.analytics) {
            console.log("Shopify.analytics is not available");
            return;
          }
        console.log("publishing event kn_add_to_cart", { source: source });
        Shopify.analytics.publish("kn_add_to_cart", { source: source });
    }
});